import { SET_CONTACT_DETAILS } from '../../constants/actions';
import { ContactInfoDto } from '../../types/ContactInfoDto';

export const setContactInfo = (payload: ContactInfoDto) => {
  return { type: SET_CONTACT_DETAILS, payload };
};
